import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupColumnKey } from "@redotech/redo-fulfillment-common/fulfillment-group-column-keys";
import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import {
  FulfillmentGroupData,
  INVENTORY_PROJECTION_LOADING,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { isOpenIsh } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import {
  inventoryProjectionLoadingLabel,
  inventoryProjectionStatusLabels,
} from "../inventory-projection-status-labels";

/** Blank for a closed group, whose status may not be closed yet. */
export function formatInventoryProjection({
  status,
  inventoryProjection,
}: Pick<FulfillmentGroupData, "status" | "inventoryProjection">): string {
  if (!inventoryProjection || !isOpenIsh(status)) {
    return "";
  }
  if (inventoryProjection === INVENTORY_PROJECTION_LOADING) {
    return inventoryProjectionLoadingLabel;
  }
  const label = inventoryProjectionStatusLabels[inventoryProjection.status];
  return inventoryProjection.inbound
    ? `${label} (ETA ${inventoryProjection.inbound.eta})`
    : label;
}

export const InventoryProjectionCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header:
      fgColumnEntries[FulfillmentGroupColumnKey.INVENTORY_PROJECTION].title,
    cell: formatInventoryProjection,
  };
